import { AccountsAPI } from '@driftt/dapper'

export const fetchAccountAttribs = () => AccountsAPI.get('/attrib')
export const fetchTeamMemberAttribs = () => AccountsAPI.get('/attrib?type=TEAMMEMBER')
export const fetchAccountSegments = (index = 0, size = 25) =>
  AccountsAPI.get(`/accounts/segment?index=${index}&size=${size}`)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/account/api.js